"use strict";
import Vue from "vue";
import "@/configuration";
import App from "./App.vue";
import router from "@/router";
import { store } from "@/store";
import i18n from "@/lang";
import ElementUI from "element-ui";
import VueClipboard from "vue-clipboard2";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "element-ui/lib/theme-chalk/icon.css";
import "@/assets/style/theme/index.css";
import "@/assets/style/main.scss";
import "@/utils/directives";
import VueMatomo from "vue-matomo";
ElementUI.Tooltip.props.openDelay.default = 1200;
Vue.use(VueClipboard);
Vue.use(VueMatomo, {
  host: `https://hma.kuajingvs.com/`,
  siteId: "1",
  router,
  requireConsent: false,
  enableLinkTracking: true,
  trackInitialView: false,
  trackerFileName: "matomo"
  // userId:'ghost'
});
Vue.config.productionTip = false;
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});
ElementUI.MenuItem.components.ElTooltip.props.openDelay.default = 1e3;
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount("#app");
